export default "__VITE_ASSET__8033e9b8__"